// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "de-DE-json" + "." + "0e98b65f" + ".chunk.js";
};